import styled from 'styled-components'
import { Link } from 'react-router-dom'

export const AuthContainer = styled.div`
  min-height: calc(100vh - 52px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`

export const AuthCard = styled.div`
  background: ${({ theme }) => theme.colors.surface};
  border-radius: 12px;
  box-shadow: ${({ theme }) => theme.colors.cardShadow};
  padding: 40px;
  border: 1px solid ${({ theme }) => theme.colors.border};
  max-width: 420px;
  width: 100%;

  @media (max-width: 720px) {
    padding: 30px 20px;
  }

  h1 {
    text-align: center;
    margin-bottom: 8px;
    color: ${({ theme }) => theme.colors.textPrimary};
    font-size: 2rem;
  }

  p {
    text-align: center;
    color: ${({ theme }) => theme.colors.textSecondary};
    margin-bottom: 32px;
    font-size: 0.95rem;
  }
`

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: ${({ theme }) => theme.colors.border};
  margin: 24px 0 16px;
`

export const BackText = styled.p`
  text-align: center;
  color: ${({ theme }) => theme.colors.textSecondary};
  font-size: 0.9rem;
  margin: 0;
`

export const StyledLink = styled(Link)`
  color: ${({ theme }) => theme.colors.primary};
  text-decoration: none;
  transition: color 0.2s ease;

  &:hover {
    color: ${({ theme }) => (theme.mode === 'dark' ? '#7c3aed' : theme.colors.primaryHover)};
    text-decoration: underline;
  }
`

export const LoadingSpinner = styled.div`
  display: flex;
  justify-content: center;
  margin: 20px 0;

  &::after {
    content: '';
    width: 40px;
    height: 40px;
    border: 4px solid ${({ theme }) => theme.colors.border};
    border-top-color: ${({ theme }) => theme.colors.primary};
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`

export const StatusIcon = styled.div`
  text-align: center;
  font-size: 4rem;
  margin-bottom: 16px;
`
